/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { useApolloClient } from '@apollo/client';
import { useEffect } from 'react';
import Subscriptions from '../graphql/Subscriptions';

interface IUseRunSubscriptionsProps {
  workerId: string | null;
  onWorkerKnowledgeIdUpdate: (knowledgeId: string) => void;
  skip?: boolean;
}

function useRunSubscriptions(props: IUseRunSubscriptionsProps) {
  const { workerId, onWorkerKnowledgeIdUpdate, skip = false } = props;

  const client = useApolloClient();

  let workerKnowledgeIdUpdateSubscription: any = null;

  const handleUpdatesError = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (!skip) {
      if (workerId) {
        // TODO: Faiyaz - check
        const observer = client.subscribe({
          query: Subscriptions.onWorkerKnowledgeIdUpdate(),
          variables: {
            id: workerId
          },
          fetchPolicy: 'network-only'
        });

        workerKnowledgeIdUpdateSubscription = observer.subscribe({
          next({ data }) {
            const knowledgeId = data?.onNotifyWorkerUpdate?.knowledgeId;
            if (knowledgeId) {
              onWorkerKnowledgeIdUpdate(knowledgeId);
            }
          },
          error(e) {
            console.log(
              'onWorkerKnowledgeIdUpdate subcription error',
              JSON.stringify(e)
            );
            handleUpdatesError();
          }
        });
      }
    }

    return () => {
      if (workerKnowledgeIdUpdateSubscription) {
        workerKnowledgeIdUpdateSubscription.unsubscribe();
      }
    };
  }, [workerId, skip]);
}

export default useRunSubscriptions;
